import { useSelector } from 'react-redux'
import { hasSessionSelector } from '../selectors'

export function useHasSession(): boolean {
  return useSelector(hasSessionSelector)
}
